import InstagramSvgIconGradient from "~/src/utils/InstagramSvgIconGradient";
import Contact from "~/src/Contact/Contact";
import NameAndBio from "~/src/NameAndBio/NameAndBio";
import Publications from "~/src/Publications/Publications";
import SelectedProjects from "~/src/SelectedProjects/SelectedProjects";

export default function Home() {
  return (
    <>
      <title>Oluwatobi Sofela - Full-Stack Developer Portfolio</title>
      <NameAndBio />
      <SelectedProjects />
      <Publications />
      <Contact />
      <InstagramSvgIconGradient />
    </>
  );
}
